module.exports = __webpack_public_path__ + "img/验证码@2x.97ea2f7d.png";